export type ExtraLang = 'ja' | 'ko' | 'es' | 'ptBR' | 'fr' | 'de';

// Generated from the canonical English UI strings and reviewed for NovaX terminology.
export const extraTranslations: Record<ExtraLang, Record<string, string>> = {
  ja: {
    "nav.memory": "ナレッジベース",
    "nav.chat": "チャット",
    "nav.contacts": "チーム",
    "nav.skillMarket": "スキルマーケット",
    "nav.settings": "設定",
    "nav.meetings": "会議",
    "nav.briefings": "ブリーフィング",
    "nav.ontology": "オントロジー",
    "meetings.hint": "チームのミーティングと議事録",
    "meetings.create": "新しい会議",
    "meetings.createHint": "今すぐ新しいルームを開始します →",
    "meetings.totalMeetings": "会議の合計数",
    "meetings.hours": "時間",
    "meetings.minutesCount": "分",
    "meetings.searchPlaceholder": "会議を検索...",
    "meetings.records": "会議記録",
    "meetings.loading": "読み込み中...",
    "meetings.empty": "まだ会議はありません",
    "meetings.emptyHint": "「新しい会議」をクリックして最初の会議を開始します",
    "memory.title": "共有された知識",
    "memory.documents": "書類",
    "memory.searchPlaceholder": "ナレッジベースを検索...",
    "memory.loading": "読み込み中...",
    "memory.empty": "ナレッジベースが空です",
    "memory.emptyHint": "すべてのエージェントの共有ルールと知識として .md ファイルをアップロードします",
    "memory.back": "戻る",
    "memory.desc": "ここでの文書は、すべてのエージェントの共有ルールと記憶として機能します。 .md ファイルのみがサポートされます。",
    "memory.upload": "アップロード",
    "memory.deleteConfirm": "この文書を削除しますか?",
    "settings.title": "設定",
    "settings.general": "一般",
    "settings.appearance": "外観",
    "settings.auth": "アカウント",
    "settings.guide": "使い方ガイド",
    "settings.about": "このアプリについて",
    "general.eyebrow": "設定",
    "general.title": "一般設定",
    "general.desc": "環境設定と組織設定を管理します。",
    "general.displayName": "表示名",
    "general.displayNamePlaceholder": "あなたの名前",
    "general.language": "言語",
    "general.defaultWorkDir": "デフォルトの作業ディレクトリ",
    "general.defaultWorkDirHint": "新しいエージェントを作成するときのデフォルトのファイル システム ルート",
    "general.chatHistory": "チャット履歴",
    "general.chatHistoryDesc": "すべてのローカル チャット セッションをクリアします。これを元に戻すことはできません。",
    "general.clearSessions": "すべてのセッションをクリアする",
    "general.saved": "保存されました",
    "profile.open": "プロフィールを開く",
    "profile.close": "プロフィールを閉じる",
    "profile.title": "プロフィール",
    "profile.uploadAvatar": "新しいアバターをアップロードする",
    "profile.chooseAvatar": "アバターを選択してください",
    "profile.presetAvatar": "プリセットアバター",
    "profile.imageTypeError": "PNG、JPG、または WebP 画像を使用します",
    "profile.imageSizeError": "画像は 2 MB 未満である必要があります",
    "profile.imageReadError": "画像を読み取れませんでした。もう一度やり直してください。",
    "profile.saveError": "保存できませんでした。後でもう一度試してください。",
    "auth.eyebrow": "安全",
    "auth.title": "アカウント",
    "auth.desc": "セッションとアカウントの設定を管理します。",
    "auth.currentToken": "現在のトークン",
    "auth.reveal": "表示",
    "auth.hide": "非表示",
    "auth.signOut": "サインアウト",
    "auth.signOutDesc": "再度アクセスするにはトークンを再入力する必要があります。",
    "about.eyebrow": "システム",
    "about.title": "について",
    "about.desc": "このアプリケーションに関する情報。",
    "about.description": "Web、Feishu、Telegram、WeChat 用の Codex を利用したマルチチャネル AI エージェント プラットフォーム。",
    "about.guideTitle": "製品ガイド",
    "about.guideDesc": "NovaX の概念とプラットフォームの使用方法について学ぶ",
    "about.agreementTitle": "ユーザー同意書とプライバシー",
    "about.agreementDesc": "データの取り扱い、利用規約、免責事項",
    "contacts.title": "あなたのチーム",
    "contacts.agents": "エージェント",
    "contacts.online": "オンライン",
    "contacts.newAgent": "+ 新しいエージェント",
    "contacts.openChat": "オープンチャット",
    "contacts.noAgents": "エージェントが構成されていません",
    "contacts.connecting": "接続中...",
    "create.title": "新しいエージェントの作成",
    "create.name": "名前",
    "create.namePlaceholder": "例えば研究者",
    "create.description": "説明",
    "create.descPlaceholder": "例えば研究助手",
    "create.soul": "Soul",
    "create.soulPlaceholder": "このエージェントの性格、指示、能力を定義します...",
    "create.cancel": "キャンセル",
    "create.create": "作成する",
    "create.creating": "作成...",
    "create.nameRequired": "名前は必須です",
    "detail.changeAvatar": "アバターの変更",
    "detail.uploadImage": "画像をアップロードする",
    "detail.choosePreset": "またはプリセットを選択してください",
    "detail.soul": "Soul",
    "detail.edit": "編集",
    "detail.save": "保存",
    "detail.saving": "保存中...",
    "detail.cancel": "キャンセル",
    "detail.noSoul": "ソウルが設定されていません — [編集] をクリックしてソウルを作成します",
    "detail.deleteAgent": "エージェントの削除",
    "detail.confirmDelete": "本気ですか？これを元に戻すことはできません。",
    "detail.yesDelete": "はい、削除します",
    "detail.deleting": "削除中...",
    "chat.conversations": "会話",
    "chat.directMessages": "ダイレクトメッセージ",
    "chat.search": "会話を検索...",
    "chat.workspace": "組織",
    "chat.groupAvatar": "全て",
    "chat.groupName": "みんな",
    "chat.groupDesc": "すべてのメンバーとエージェントとのグループ チャット",
    "chat.newGroup": "新しいグループ",
    "chat.createGroup": "グループの作成",
    "chat.groupNameLabel": "グループ名",
    "chat.groupNamePlaceholder": "グループ名を入力してください...",
    "chat.selectMembers": "メンバーの選択",
    "chat.minMembers": "少なくとも 2 人のメンバーを選択してください",
    "chat.creating": "作成...",
    "chat.editGroup": "グループの編集",
    "chat.deleteGroup": "グループの削除",
    "chat.deleteGroupConfirm": "このグループを削除しますか?チャット履歴は消去されます。",
    "chat.groups": "グループ",
    "chat.messages": "メッセージ",
    "chat.tasks": "タスク",
    "chat.skill": "スキル",
    "skill.installed": "インストール済み",
    "skill.marketplace": "市場",
    "skill.official": "正式",
    "skill.custom": "カスタム",
    "skill.install": "インストール",
    "skill.installing": "インストール中...",
    "skill.installed_badge": "インストール済み",
    "skill.uninstall": "アンインストール",
    "skill.noSkills": "スキルなし",
    "skill.noSkillsHint": "マーケットプレイスからスキルをインストールする",
    "skill.marketplaceEmpty": "利用可能なスキルはありません",
    "skill.invocable": "呼び出し可能",
    "skill.back": "戻る",
    "skill.execMode": "実行モード",
    "skill.allowedTools": "許可されたツール",
    "chat.memory": "メモリ",
    "chat.files": "ファイル",
    "chat.online": "オンライン",
    "chat.offline": "オフライン",
    "chat.research": "研究",
    "chat.noAgents": "エージェントが構成されていません",
    "chat.connecting": "接続中...",
    "chat.selectAgent": "会話を開始するエージェントを選択してください",
    "chat.startConversation": "会話を始める",
    "contacts.capabilities": "能力",
    "contacts.busy": "忙しい",
    "contacts.statusOnline": "オンライン",
    "contacts.statusOffline": "オフライン",
    "team.members": "メンバー",
    "team.agents": "エージェント",
    "team.invite": "招待する",
    "team.inviteTitle": "メンバーを招待する",
    "team.inviteDesc": "この組織にメンバーを招待するには電子メールを入力してください",
    "team.email": "電子メール",
    "team.emailPlaceholder": "メールアドレスを入力してください",
    "team.role": "役割",
    "team.send": "招待を送信する",
    "team.sending": "送信中...",
    "team.sent": "招待状を送信しました",
    "team.cancel": "キャンセル",
    "team.owner": "所有者",
    "team.admin": "管理者",
    "team.member": "メンバー",
    "team.remove": "取り除く",
    "team.pendingInvites": "保留中の招待",
    "team.revoke": "取り消す",
    "team.stats": "統計",
    "team.noMembers": "他のメンバーはまだいません",
    "team.noPending": "保留中の招待はありません",
    "team.switchWorkspace": "組織の切り替え",
    "msg.thinking": "考え...",
    "msg.running": "ランニング",
    "msg.error": "エラーが発生しました",
    "msg.toolCalls": "ツール呼び出しが完了しました",
    "time.justNow": "ちょうど今",
    "time.minutesAgo": "分前",
    "time.hoursAgo": "時間前",
  },
  ko: {
    "nav.memory": "지식 베이스",
    "nav.chat": "채팅",
    "nav.contacts": "팀",
    "nav.skillMarket": "스킬마켓",
    "nav.settings": "설정",
    "nav.meetings": "회의",
    "nav.briefings": "브리핑",
    "nav.ontology": "존재론",
    "meetings.hint": "팀 회의 및 회의록",
    "meetings.create": "새 회의",
    "meetings.createHint": "지금 새 방을 시작하세요 →",
    "meetings.totalMeetings": "총 회의",
    "meetings.hours": "시간",
    "meetings.minutesCount": "분",
    "meetings.searchPlaceholder": "회의 검색...",
    "meetings.records": "회의 기록",
    "meetings.loading": "로드 중...",
    "meetings.empty": "아직 회의가 없습니다.",
    "meetings.emptyHint": "첫 번째 회의를 시작하려면 \"새 회의\"를 클릭하세요.",
    "memory.title": "공유된 지식",
    "memory.documents": "서류",
    "memory.searchPlaceholder": "기술 자료 검색...",
    "memory.loading": "로드 중...",
    "memory.empty": "기술 자료가 비어 있습니다.",
    "memory.emptyHint": "모든 상담원을 위한 공유 규칙 및 지식으로 .md 파일 업로드",
    "memory.back": "뒤쪽에",
    "memory.desc": "여기에 있는 문서는 모든 에이전트의 공유 규칙이자 메모리 역할을 합니다. .md 파일만 지원됩니다.",
    "memory.upload": "업로드",
    "memory.deleteConfirm": "이 문서를 삭제하시겠습니까?",
    "settings.title": "설정",
    "settings.general": "일반",
    "settings.appearance": "화면 설정",
    "settings.auth": "계정",
    "settings.guide": "사용 안내",
    "settings.about": "정보",
    "general.eyebrow": "환경설정",
    "general.title": "일반 설정",
    "general.desc": "기본 설정 및 조직 설정을 관리하세요.",
    "general.displayName": "표시 이름",
    "general.displayNamePlaceholder": "당신의 이름",
    "general.language": "언어",
    "general.defaultWorkDir": "기본 작업 디렉터리",
    "general.defaultWorkDirHint": "새 에이전트 생성 시 기본 파일 시스템 루트",
    "general.chatHistory": "채팅 기록",
    "general.chatHistoryDesc": "모든 로컬 채팅 세션을 지웁니다. 이 작업은 취소할 수 없습니다.",
    "general.clearSessions": "모든 세션 지우기",
    "general.saved": "저장됨",
    "profile.open": "프로필 열기",
    "profile.close": "프로필 닫기",
    "profile.title": "윤곽",
    "profile.uploadAvatar": "새 아바타 업로드",
    "profile.chooseAvatar": "아바타를 선택하세요",
    "profile.presetAvatar": "사전 설정된 아바타",
    "profile.imageTypeError": "PNG, JPG 또는 WebP 이미지를 사용하세요.",
    "profile.imageSizeError": "이미지는 2MB 미만이어야 합니다.",
    "profile.imageReadError": "이미지를 읽을 수 없습니다. 다시 시도해 보세요.",
    "profile.saveError": "저장할 수 없습니다. 나중에 다시 시도하세요.",
    "auth.eyebrow": "보안",
    "auth.title": "계정",
    "auth.desc": "세션 및 계정 설정을 관리하세요.",
    "auth.currentToken": "현재 토큰",
    "auth.reveal": "표시",
    "auth.hide": "숨기기",
    "auth.signOut": "로그아웃",
    "auth.signOutDesc": "다시 액세스하려면 토큰을 다시 입력해야 합니다.",
    "about.eyebrow": "체계",
    "about.title": "에 대한",
    "about.desc": "이 응용 프로그램에 대한 정보입니다.",
    "about.description": "Web, Feishu, Telegram 및 WeChat을 위한 Codex 기반 다중 채널 AI 에이전트 플랫폼입니다.",
    "about.guideTitle": "제품 가이드",
    "about.guideDesc": "NovaX 개념과 플랫폼 사용 방법에 대해 알아보세요.",
    "about.agreementTitle": "사용자 계약 및 개인정보 보호",
    "about.agreementDesc": "데이터 처리, 서비스 약관 및 면책 조항",
    "contacts.title": "당신의 팀",
    "contacts.agents": "자치령 대표)",
    "contacts.online": "온라인",
    "contacts.newAgent": "+ 새로운 에이전트",
    "contacts.openChat": "오픈채팅",
    "contacts.noAgents": "구성된 에이전트 없음",
    "contacts.connecting": "연결 중...",
    "create.title": "새 에이전트 만들기",
    "create.name": "이름",
    "create.namePlaceholder": "예를 들어 연구원",
    "create.description": "설명",
    "create.descPlaceholder": "예를 들어 연구 조교",
    "create.soul": "Soul",
    "create.soulPlaceholder": "이 에이전트의 성격, 지침 및 기능을 정의합니다...",
    "create.cancel": "취소",
    "create.create": "만들다",
    "create.creating": "만드는 중...",
    "create.nameRequired": "이름은 필수입니다",
    "detail.changeAvatar": "아바타 변경",
    "detail.uploadImage": "이미지 업로드",
    "detail.choosePreset": "또는 사전 설정을 선택하세요",
    "detail.soul": "Soul",
    "detail.edit": "편집하다",
    "detail.save": "구하다",
    "detail.saving": "절약...",
    "detail.cancel": "취소",
    "detail.noSoul": "영혼이 구성되지 않았습니다. 영혼을 만들려면 편집을 클릭하세요.",
    "detail.deleteAgent": "에이전트 삭제",
    "detail.confirmDelete": "확실합니까? 이 작업은 취소할 수 없습니다.",
    "detail.yesDelete": "예, 삭제합니다",
    "detail.deleting": "삭제 중...",
    "chat.conversations": "대화",
    "chat.directMessages": "직접 메시지",
    "chat.search": "대화 검색...",
    "chat.workspace": "조직",
    "chat.groupAvatar": "모두",
    "chat.groupName": "모든 사람",
    "chat.groupDesc": "모든 회원 및 상담원과의 그룹 채팅",
    "chat.newGroup": "새 그룹",
    "chat.createGroup": "그룹 만들기",
    "chat.groupNameLabel": "그룹 이름",
    "chat.groupNamePlaceholder": "그룹 이름을 입력하세요...",
    "chat.selectMembers": "회원 선택",
    "chat.minMembers": "구성원을 2명 이상 선택하세요.",
    "chat.creating": "만드는 중...",
    "chat.editGroup": "그룹 편집",
    "chat.deleteGroup": "그룹 삭제",
    "chat.deleteGroupConfirm": "이 그룹을 삭제하시겠습니까? 채팅 기록이 삭제됩니다.",
    "chat.groups": "여러 떼",
    "chat.messages": "메시지",
    "chat.tasks": "작업",
    "chat.skill": "기능",
    "skill.installed": "설치됨",
    "skill.marketplace": "시장",
    "skill.official": "공식적인",
    "skill.custom": "관습",
    "skill.install": "설치하다",
    "skill.installing": "설치 중...",
    "skill.installed_badge": "설치됨",
    "skill.uninstall": "제거",
    "skill.noSkills": "기술 없음",
    "skill.noSkillsHint": "마켓플레이스에서 기술 설치",
    "skill.marketplaceEmpty": "사용 가능한 기술이 없습니다.",
    "skill.invocable": "호출 가능",
    "skill.back": "뒤쪽에",
    "skill.execMode": "실행 모드",
    "skill.allowedTools": "허용된 도구",
    "chat.memory": "메모리",
    "chat.files": "파일",
    "chat.online": "온라인",
    "chat.offline": "오프라인",
    "chat.research": "연구",
    "chat.noAgents": "구성된 에이전트 없음",
    "chat.connecting": "연결 중...",
    "chat.selectAgent": "대화를 시작하려면 상담원을 선택하세요.",
    "chat.startConversation": "대화 시작",
    "contacts.capabilities": "능력",
    "contacts.busy": "바쁘다",
    "contacts.statusOnline": "온라인",
    "contacts.statusOffline": "오프라인",
    "team.members": "회원",
    "team.agents": "자치령 대표",
    "team.invite": "초대하다",
    "team.inviteTitle": "회원 초대",
    "team.inviteDesc": "이 조직에 구성원을 초대하려면 이메일을 입력하세요.",
    "team.email": "이메일",
    "team.emailPlaceholder": "이메일 주소를 입력하세요",
    "team.role": "역할",
    "team.send": "초대장 보내기",
    "team.sending": "배상...",
    "team.sent": "초대장이 전송되었습니다",
    "team.cancel": "취소",
    "team.owner": "소유자",
    "team.admin": "관리자",
    "team.member": "회원",
    "team.remove": "제거하다",
    "team.pendingInvites": "대기 중인 초대",
    "team.revoke": "취소",
    "team.stats": "통계",
    "team.noMembers": "아직 다른 회원이 없습니다.",
    "team.noPending": "대기 중인 초대 없음",
    "team.switchWorkspace": "조직 전환",
    "msg.thinking": "생각...",
    "msg.running": "달리기",
    "msg.error": "오류가 발생했습니다",
    "msg.toolCalls": "도구 호출 완료",
    "time.justNow": "방금",
    "time.minutesAgo": "몇 분 전",
    "time.hoursAgo": "시간 전",
  },
  es: {
    "nav.memory": "Base de conocimiento",
    "nav.chat": "Charlar",
    "nav.contacts": "Equipo",
    "nav.skillMarket": "Mercado de habilidades",
    "nav.settings": "Ajustes",
    "nav.meetings": "Reuniones",
    "nav.briefings": "Informes",
    "nav.ontology": "Ontología",
    "meetings.hint": "Reuniones y actas del equipo",
    "meetings.create": "Nueva reunión",
    "meetings.createHint": "Iniciar una nueva sala ahora →",
    "meetings.totalMeetings": "Total de reuniones",
    "meetings.hours": "horas",
    "meetings.minutesCount": "minutos",
    "meetings.searchPlaceholder": "Buscar reuniones...",
    "meetings.records": "Registros de reuniones",
    "meetings.loading": "Cargando...",
    "meetings.empty": "Aún no hay reuniones",
    "meetings.emptyHint": "Haga clic en \"Nueva reunión\" para iniciar su primera reunión",
    "memory.title": "Conocimiento compartido",
    "memory.documents": "documentos",
    "memory.searchPlaceholder": "Buscar en la base de conocimientos...",
    "memory.loading": "Cargando...",
    "memory.empty": "La base de conocimientos está vacía.",
    "memory.emptyHint": "Cargue archivos .md como reglas y conocimientos compartidos para todos los agentes",
    "memory.back": "Atrás",
    "memory.desc": "Los documentos aquí sirven como reglas y memoria compartida para todos los agentes. Sólo se admiten archivos .md.",
    "memory.upload": "Subir",
    "memory.deleteConfirm": "¿Eliminar este documento?",
    "settings.title": "Ajustes",
    "settings.general": "General",
    "settings.appearance": "Apariencia",
    "settings.auth": "Cuenta",
    "settings.guide": "Guía de uso",
    "settings.about": "Acerca de",
    "general.eyebrow": "Preferencias",
    "general.title": "General",
    "general.desc": "Administre sus preferencias y configuración de la organización.",
    "general.displayName": "Nombre para mostrar",
    "general.displayNamePlaceholder": "Su nombre",
    "general.language": "Idioma",
    "general.defaultWorkDir": "Directorio de trabajo predeterminado",
    "general.defaultWorkDirHint": "Raíz del sistema de archivos predeterminado al crear nuevos agentes",
    "general.chatHistory": "Historial de chat",
    "general.chatHistoryDesc": "Borrar todas las sesiones de chat locales. Esto no se puede deshacer.",
    "general.clearSessions": "Borrar todas las sesiones",
    "general.saved": "Guardado",
    "profile.open": "Abrir perfil",
    "profile.close": "Cerrar perfil",
    "profile.title": "Perfil",
    "profile.uploadAvatar": "Subir nuevo avatar",
    "profile.chooseAvatar": "Elige un avatar",
    "profile.presetAvatar": "avatar preestablecido",
    "profile.imageTypeError": "Utilice una imagen PNG, JPG o WebP",
    "profile.imageSizeError": "La imagen debe tener menos de 2 MB.",
    "profile.imageReadError": "No se pudo leer la imagen. Intentar otra vez.",
    "profile.saveError": "No se pudo guardar. Vuelve a intentarlo más tarde.",
    "auth.eyebrow": "Seguridad",
    "auth.title": "Cuenta",
    "auth.desc": "Administre su sesión y la configuración de su cuenta.",
    "auth.currentToken": "token actual",
    "auth.reveal": "Mostrar",
    "auth.hide": "Ocultar",
    "auth.signOut": "desconectar",
    "auth.signOutDesc": "Deberá volver a ingresar el token para acceder nuevamente.",
    "about.eyebrow": "Sistema",
    "about.title": "Acerca de",
    "about.desc": "Información sobre esta aplicación.",
    "about.description": "Una plataforma de agentes de IA multicanal impulsada por Codex para Web, Feishu, Telegram y WeChat.",
    "about.guideTitle": "Guía de productos",
    "about.guideDesc": "Conozca los conceptos de NovaX y cómo utilizar la plataforma.",
    "about.agreementTitle": "Acuerdo de usuario y privacidad",
    "about.agreementDesc": "Manejo de datos, términos de servicio y descargos de responsabilidad",
    "contacts.title": "tu equipo",
    "contacts.agents": "agente(s)",
    "contacts.online": "en línea",
    "contacts.newAgent": "+ Nuevo agente",
    "contacts.openChat": "abrir chat",
    "contacts.noAgents": "No hay agentes configurados",
    "contacts.connecting": "Conectando...",
    "create.title": "Crear nuevo agente",
    "create.name": "Nombre",
    "create.namePlaceholder": "p.ej. investigador",
    "create.description": "Descripción",
    "create.descPlaceholder": "p.ej. asistente de investigación",
    "create.soul": "Soul",
    "create.soulPlaceholder": "Defina la personalidad, instrucciones y capacidades de este agente...",
    "create.cancel": "Cancelar",
    "create.create": "Crear",
    "create.creating": "Creando...",
    "create.nameRequired": "El nombre es obligatorio",
    "detail.changeAvatar": "Cambiar avatar",
    "detail.uploadImage": "Subir imagen",
    "detail.choosePreset": "O ELEGIR UN PRESET",
    "detail.soul": "Soul",
    "detail.edit": "Editar",
    "detail.save": "Ahorrar",
    "detail.saving": "Ahorro...",
    "detail.cancel": "Cancelar",
    "detail.noSoul": "No hay alma configurada: haz clic en Editar para crear una",
    "detail.deleteAgent": "Eliminar agente",
    "detail.confirmDelete": "¿Está seguro? Esto no se puede deshacer.",
    "detail.yesDelete": "Si, eliminar",
    "detail.deleting": "Eliminando...",
    "chat.conversations": "Conversaciones",
    "chat.directMessages": "Mensajes directos",
    "chat.search": "Buscar conversaciones...",
    "chat.workspace": "Organización",
    "chat.groupAvatar": "Todo",
    "chat.groupName": "Todos",
    "chat.groupDesc": "Chat grupal con todos los miembros y agentes.",
    "chat.newGroup": "Nuevo grupo",
    "chat.createGroup": "Crear grupo",
    "chat.groupNameLabel": "Nombre del grupo",
    "chat.groupNamePlaceholder": "Introduce el nombre del grupo...",
    "chat.selectMembers": "Seleccionar miembros",
    "chat.minMembers": "Seleccione al menos 2 miembros",
    "chat.creating": "Creando...",
    "chat.editGroup": "Editar grupo",
    "chat.deleteGroup": "Eliminar grupo",
    "chat.deleteGroupConfirm": "¿Eliminar este grupo? Se borrará el historial de chat.",
    "chat.groups": "Grupos",
    "chat.messages": "Mensajes",
    "chat.tasks": "Tareas",
    "chat.skill": "Habilidad",
    "skill.installed": "Instalado",
    "skill.marketplace": "Mercado",
    "skill.official": "Oficial",
    "skill.custom": "Costumbre",
    "skill.install": "Instalar",
    "skill.installing": "Instalando...",
    "skill.installed_badge": "Instalado",
    "skill.uninstall": "Desinstalar",
    "skill.noSkills": "Sin habilidades",
    "skill.noSkillsHint": "Instalar habilidades del mercado",
    "skill.marketplaceEmpty": "No hay habilidades disponibles",
    "skill.invocable": "invocable",
    "skill.back": "Atrás",
    "skill.execMode": "Modo ejecutivo",
    "skill.allowedTools": "Herramientas permitidas",
    "chat.memory": "Memoria",
    "chat.files": "Archivos",
    "chat.online": "EN LÍNEA",
    "chat.offline": "DESCONECTADO",
    "chat.research": "INVESTIGACIÓN",
    "chat.noAgents": "No hay agentes configurados",
    "chat.connecting": "Conectando...",
    "chat.selectAgent": "Seleccione un agente para iniciar una conversación",
    "chat.startConversation": "iniciar una conversación",
    "contacts.capabilities": "CAPACIDADES",
    "contacts.busy": "OCUPADO",
    "contacts.statusOnline": "EN LÍNEA",
    "contacts.statusOffline": "DESCONECTADO",
    "team.members": "Miembros",
    "team.agents": "Agentes",
    "team.invite": "Invitar",
    "team.inviteTitle": "Invitar miembro",
    "team.inviteDesc": "Ingrese el correo electrónico para invitar a un miembro a esta organización",
    "team.email": "Correo electrónico",
    "team.emailPlaceholder": "Introduzca la dirección de correo electrónico",
    "team.role": "Role",
    "team.send": "Enviar invitación",
    "team.sending": "Envío...",
    "team.sent": "Invitación enviada",
    "team.cancel": "Cancelar",
    "team.owner": "Dueño",
    "team.admin": "Administración",
    "team.member": "Miembro",
    "team.remove": "Eliminar",
    "team.pendingInvites": "Invitaciones pendientes",
    "team.revoke": "Revocar",
    "team.stats": "Estadística",
    "team.noMembers": "Ningún otro miembro todavía",
    "team.noPending": "No hay invitaciones pendientes",
    "team.switchWorkspace": "Cambiar de organización",
    "msg.thinking": "Pensamiento...",
    "msg.running": "Correr",
    "msg.error": "Se produjo un error",
    "msg.toolCalls": "Llamadas a herramientas completadas",
    "time.justNow": "En este momento",
    "time.minutesAgo": "hace m",
    "time.hoursAgo": "hace h",
  },
  ptBR: {
    "nav.memory": "Base de conhecimento",
    "nav.chat": "Bater papo",
    "nav.contacts": "Equipe",
    "nav.skillMarket": "Mercado de habilidades",
    "nav.settings": "Configurações",
    "nav.meetings": "Reuniões",
    "nav.briefings": "Boletins",
    "nav.ontology": "Ontologia",
    "meetings.hint": "Reuniões e atas da equipe",
    "meetings.create": "Nova Reunião",
    "meetings.createHint": "Comece uma nova sala agora →",
    "meetings.totalMeetings": "Total de reuniões",
    "meetings.hours": "horas",
    "meetings.minutesCount": "minutos",
    "meetings.searchPlaceholder": "Pesquisar reuniões...",
    "meetings.records": "Registros de reuniões",
    "meetings.loading": "Carregando...",
    "meetings.empty": "Ainda não há reuniões",
    "meetings.emptyHint": "Clique em \"Nova Reunião\" para iniciar sua primeira reunião",
    "memory.title": "Conhecimento Compartilhado",
    "memory.documents": "documentos",
    "memory.searchPlaceholder": "Pesquisar base de conhecimento...",
    "memory.loading": "Carregando...",
    "memory.empty": "A base de conhecimento está vazia",
    "memory.emptyHint": "Faça upload de arquivos .md como regras e conhecimentos compartilhados para todos os agentes",
    "memory.back": "Voltar",
    "memory.desc": "Os documentos aqui servem como regras e memória compartilhadas para todos os agentes. Somente arquivos .md são suportados.",
    "memory.upload": "Carregar",
    "memory.deleteConfirm": "Excluir este documento?",
    "settings.title": "Configurações",
    "settings.general": "Geral",
    "settings.appearance": "Aparência",
    "settings.auth": "Conta",
    "settings.guide": "Guia de uso",
    "settings.about": "Sobre",
    "general.eyebrow": "Preferências",
    "general.title": "Configurações gerais",
    "general.desc": "Gerencie suas preferências e configurações da organização.",
    "general.displayName": "Nome de exibição",
    "general.displayNamePlaceholder": "Seu nome",
    "general.language": "Idioma",
    "general.defaultWorkDir": "Diretório de trabalho padrão",
    "general.defaultWorkDirHint": "Raiz padrão do sistema de arquivos ao criar novos agentes",
    "general.chatHistory": "Histórico de bate-papo",
    "general.chatHistoryDesc": "Limpe todas as sessões de chat locais. Isto não pode ser desfeito.",
    "general.clearSessions": "Limpar todas as sessões",
    "general.saved": "Salvo",
    "profile.open": "Abrir perfil",
    "profile.close": "Fechar perfil",
    "profile.title": "Perfil",
    "profile.uploadAvatar": "Carregar novo avatar",
    "profile.chooseAvatar": "Escolha um avatar",
    "profile.presetAvatar": "Avatar predefinido",
    "profile.imageTypeError": "Use uma imagem PNG, JPG ou WebP",
    "profile.imageSizeError": "A imagem deve ter menos de 2 MB",
    "profile.imageReadError": "Não foi possível ler a imagem. Tente novamente.",
    "profile.saveError": "Não foi possível salvar. Tente novamente mais tarde.",
    "auth.eyebrow": "Segurança",
    "auth.title": "Conta",
    "auth.desc": "Gerencie suas configurações de sessão e conta.",
    "auth.currentToken": "Token atual",
    "auth.reveal": "Mostrar",
    "auth.hide": "Ocultar",
    "auth.signOut": "sair",
    "auth.signOutDesc": "Você precisará inserir novamente o token para acessar novamente.",
    "about.eyebrow": "Sistema",
    "about.title": "Sobre",
    "about.desc": "Informações sobre este aplicativo.",
    "about.description": "Uma plataforma de agente de IA multicanal baseada em Codex para Web, Feishu, Telegram e WeChat.",
    "about.guideTitle": "Guia do produto",
    "about.guideDesc": "Conheça os conceitos da NovaX e como usar a plataforma",
    "about.agreementTitle": "Contrato do usuário e privacidade",
    "about.agreementDesc": "Tratamento de dados, termos de serviço e isenções de responsabilidade",
    "contacts.title": "Sua equipe",
    "contacts.agents": "agente(s)",
    "contacts.online": "on-line",
    "contacts.newAgent": "+ Novo agente",
    "contacts.openChat": "Abrir bate-papo",
    "contacts.noAgents": "Nenhum agente configurado",
    "contacts.connecting": "Conectando...",
    "create.title": "Criar novo agente",
    "create.name": "Nome",
    "create.namePlaceholder": "por exemplo pesquisador",
    "create.description": "Descrição",
    "create.descPlaceholder": "por exemplo Assistente de pesquisa",
    "create.soul": "Soul",
    "create.soulPlaceholder": "Defina a personalidade, as instruções e as capacidades deste agente...",
    "create.cancel": "Cancelar",
    "create.create": "Criar",
    "create.creating": "Criando...",
    "create.nameRequired": "O nome é obrigatório",
    "detail.changeAvatar": "Alterar avatar",
    "detail.uploadImage": "Carregar imagem",
    "detail.choosePreset": "OU ESCOLHA UM PRESET",
    "detail.soul": "Soul",
    "detail.edit": "Editar",
    "detail.save": "Salvar",
    "detail.saving": "Salvando...",
    "detail.cancel": "Cancelar",
    "detail.noSoul": "Nenhuma alma configurada – clique em Editar para criar uma",
    "detail.deleteAgent": "Excluir agente",
    "detail.confirmDelete": "Tem certeza? Isto não pode ser desfeito.",
    "detail.yesDelete": "Sim, excluir",
    "detail.deleting": "Excluindo...",
    "chat.conversations": "Conversas",
    "chat.directMessages": "Mensagens Diretas",
    "chat.search": "Pesquisar conversas...",
    "chat.workspace": "Organização",
    "chat.groupAvatar": "Todos",
    "chat.groupName": "Todos",
    "chat.groupDesc": "Bate-papo em grupo com todos os membros e agentes",
    "chat.newGroup": "Novo grupo",
    "chat.createGroup": "Criar grupo",
    "chat.groupNameLabel": "Nome do grupo",
    "chat.groupNamePlaceholder": "Digite o nome do grupo...",
    "chat.selectMembers": "Selecione membros",
    "chat.minMembers": "Selecione pelo menos 2 membros",
    "chat.creating": "Criando...",
    "chat.editGroup": "Editar grupo",
    "chat.deleteGroup": "Excluir grupo",
    "chat.deleteGroupConfirm": "Excluir este grupo? O histórico de bate-papo será limpo.",
    "chat.groups": "Grupos",
    "chat.messages": "Mensagens",
    "chat.tasks": "Tarefas",
    "chat.skill": "Habilidade",
    "skill.installed": "Instalado",
    "skill.marketplace": "Mercado",
    "skill.official": "Oficial",
    "skill.custom": "Personalizado",
    "skill.install": "Instalar",
    "skill.installing": "Instalando...",
    "skill.installed_badge": "Instalado",
    "skill.uninstall": "Desinstalar",
    "skill.noSkills": "Sem habilidades",
    "skill.noSkillsHint": "Instale habilidades do mercado",
    "skill.marketplaceEmpty": "Nenhuma habilidade disponível",
    "skill.invocable": "Invocável",
    "skill.back": "Voltar",
    "skill.execMode": "Modo Executivo",
    "skill.allowedTools": "Ferramentas permitidas",
    "chat.memory": "Memória",
    "chat.files": "Arquivos",
    "chat.online": "ON-LINE",
    "chat.offline": "OFF-LINE",
    "chat.research": "PESQUISAR",
    "chat.noAgents": "Nenhum agente configurado",
    "chat.connecting": "Conectando...",
    "chat.selectAgent": "Selecione um agente para iniciar uma conversa",
    "chat.startConversation": "Inicie uma conversa",
    "contacts.capabilities": "CAPACIDADES",
    "contacts.busy": "OCUPADO",
    "contacts.statusOnline": "ON-LINE",
    "contacts.statusOffline": "OFF-LINE",
    "team.members": "Membros",
    "team.agents": "Agentes",
    "team.invite": "Convidar",
    "team.inviteTitle": "Convidar membro",
    "team.inviteDesc": "Digite o e-mail para convidar um membro para esta organização",
    "team.email": "E-mail",
    "team.emailPlaceholder": "Digite o endereço de e-mail",
    "team.role": "Papel",
    "team.send": "Enviar convite",
    "team.sending": "Enviando...",
    "team.sent": "Convite enviado",
    "team.cancel": "Cancelar",
    "team.owner": "Proprietário",
    "team.admin": "Administrador",
    "team.member": "Membro",
    "team.remove": "Remover",
    "team.pendingInvites": "Convites pendentes",
    "team.revoke": "Revogar",
    "team.stats": "Estatísticas",
    "team.noMembers": "Nenhum outro membro ainda",
    "team.noPending": "Nenhum convite pendente",
    "team.switchWorkspace": "Mudar de organização",
    "msg.thinking": "Pensamento...",
    "msg.running": "Correndo",
    "msg.error": "Ocorreu um erro",
    "msg.toolCalls": "chamada(s) de ferramenta concluída(s)",
    "time.justNow": "Agora mesmo",
    "time.minutesAgo": "há muito tempo",
    "time.hoursAgo": "h atrás",
  },
  fr: {
    "nav.memory": "Base de connaissances",
    "nav.chat": "Chat",
    "nav.contacts": "Équipe",
    "nav.skillMarket": "Marché des compétences",
    "nav.settings": "Paramètres",
    "nav.meetings": "Réunions",
    "nav.briefings": "Briefings",
    "nav.ontology": "Ontologie",
    "meetings.hint": "Réunions d'équipe et procès-verbaux",
    "meetings.create": "Nouvelle réunion",
    "meetings.createHint": "Créez une nouvelle salle maintenant →",
    "meetings.totalMeetings": "Total des réunions",
    "meetings.hours": "heures",
    "meetings.minutesCount": "minutes",
    "meetings.searchPlaceholder": "Rechercher des réunions...",
    "meetings.records": "Comptes rendus des réunions",
    "meetings.loading": "Chargement...",
    "meetings.empty": "Pas encore de réunions",
    "meetings.emptyHint": "Cliquez sur \"Nouvelle réunion\" pour démarrer votre première réunion",
    "memory.title": "Connaissance partagée",
    "memory.documents": "documents",
    "memory.searchPlaceholder": "Rechercher dans la base de connaissances...",
    "memory.loading": "Chargement...",
    "memory.empty": "La base de connaissances est vide",
    "memory.emptyHint": "Téléchargez des fichiers .md en tant que règles et connaissances partagées pour tous les agents",
    "memory.back": "Dos",
    "memory.desc": "Les documents ici servent de règles partagées et de mémoire pour tous les agents. Seuls les fichiers .md sont pris en charge.",
    "memory.upload": "Télécharger",
    "memory.deleteConfirm": "Supprimer ce document ?",
    "settings.title": "Paramètres",
    "settings.general": "Général",
    "settings.appearance": "Apparence",
    "settings.auth": "Compte",
    "settings.guide": "Guide d’utilisation",
    "settings.about": "À propos",
    "general.eyebrow": "Préférences",
    "general.title": "Général",
    "general.desc": "Gérez vos préférences et les paramètres de votre organisation.",
    "general.displayName": "Nom d'affichage",
    "general.displayNamePlaceholder": "Votre nom",
    "general.language": "Langue",
    "general.defaultWorkDir": "Répertoire de travail par défaut",
    "general.defaultWorkDirHint": "Racine du système de fichiers par défaut lors de la création de nouveaux agents",
    "general.chatHistory": "Historique des discussions",
    "general.chatHistoryDesc": "Effacez toutes les sessions de discussion locales. Cela ne peut pas être annulé.",
    "general.clearSessions": "Effacer toutes les sessions",
    "general.saved": "Enregistré",
    "profile.open": "Ouvrir le profil",
    "profile.close": "Fermer le profil",
    "profile.title": "Profil",
    "profile.uploadAvatar": "Télécharger un nouvel avatar",
    "profile.chooseAvatar": "Choisissez un avatar",
    "profile.presetAvatar": "Avatar prédéfini",
    "profile.imageTypeError": "Utilisez une image PNG, JPG ou WebP",
    "profile.imageSizeError": "L'image doit faire moins de 2 Mo",
    "profile.imageReadError": "Impossible de lire l'image. Essayer à nouveau.",
    "profile.saveError": "Impossible d'enregistrer. Réessayez plus tard.",
    "auth.eyebrow": "Sécurité",
    "auth.title": "Compte",
    "auth.desc": "Gérez les paramètres de votre session et de votre compte.",
    "auth.currentToken": "Jeton actuel",
    "auth.reveal": "Afficher",
    "auth.hide": "Masquer",
    "auth.signOut": "se déconnecter",
    "auth.signOutDesc": "Vous devrez ressaisir le jeton pour y accéder à nouveau.",
    "about.eyebrow": "Système",
    "about.title": "À propos",
    "about.desc": "Informations sur cette application.",
    "about.description": "Une plateforme d’agents IA multicanal propulsée par Codex pour le Web, Feishu, Telegram et WeChat.",
    "about.guideTitle": "Guide produit",
    "about.guideDesc": "Découvrez les concepts de NovaX et comment utiliser la plateforme",
    "about.agreementTitle": "Accord d'utilisation et confidentialité",
    "about.agreementDesc": "Traitement des données, conditions d'utilisation et clauses de non-responsabilité",
    "contacts.title": "Votre équipe",
    "contacts.agents": "agent(s)",
    "contacts.online": "en ligne",
    "contacts.newAgent": "+ Nouvel agent",
    "contacts.openChat": "Ouvrir le chat",
    "contacts.noAgents": "Aucun agent configuré",
    "contacts.connecting": "De liaison...",
    "create.title": "Créer un nouvel agent",
    "create.name": "Nom",
    "create.namePlaceholder": "par ex. chercheur",
    "create.description": "Description",
    "create.descPlaceholder": "par ex. Assistante de recherche",
    "create.soul": "Soul",
    "create.soulPlaceholder": "Définir la personnalité, les instructions et les capacités de cet agent...",
    "create.cancel": "Annuler",
    "create.create": "Créer",
    "create.creating": "Création...",
    "create.nameRequired": "Le nom est requis",
    "detail.changeAvatar": "Changer d'avatar",
    "detail.uploadImage": "Télécharger une image",
    "detail.choosePreset": "OU CHOISISSEZ UN PRÉRÉGLAGE",
    "detail.soul": "Soul",
    "detail.edit": "Modifier",
    "detail.save": "Sauvegarder",
    "detail.saving": "Économie...",
    "detail.cancel": "Annuler",
    "detail.noSoul": "Aucune âme configurée — cliquez sur Modifier pour en créer une",
    "detail.deleteAgent": "Supprimer un agent",
    "detail.confirmDelete": "Es-tu sûr? Cela ne peut pas être annulé.",
    "detail.yesDelete": "Oui, supprimer",
    "detail.deleting": "Suppression...",
    "chat.conversations": "Conversations",
    "chat.directMessages": "Messages directs",
    "chat.search": "Rechercher des conversations...",
    "chat.workspace": "Organisation",
    "chat.groupAvatar": "Tous",
    "chat.groupName": "Tout le monde",
    "chat.groupDesc": "Discussion de groupe avec tous les membres et agents",
    "chat.newGroup": "Nouveau groupe",
    "chat.createGroup": "Créer un groupe",
    "chat.groupNameLabel": "Nom du groupe",
    "chat.groupNamePlaceholder": "Entrez le nom du groupe...",
    "chat.selectMembers": "Sélectionnez les membres",
    "chat.minMembers": "Sélectionnez au moins 2 membres",
    "chat.creating": "Création...",
    "chat.editGroup": "Modifier le groupe",
    "chat.deleteGroup": "Supprimer le groupe",
    "chat.deleteGroupConfirm": "Supprimer ce groupe ? L'historique des discussions sera effacé.",
    "chat.groups": "Groupes",
    "chat.messages": "Messages",
    "chat.tasks": "Tâches",
    "chat.skill": "Compétence",
    "skill.installed": "Installé",
    "skill.marketplace": "Marché",
    "skill.official": "Officiel",
    "skill.custom": "Coutume",
    "skill.install": "Installer",
    "skill.installing": "Installation...",
    "skill.installed_badge": "Installé",
    "skill.uninstall": "Désinstaller",
    "skill.noSkills": "Aucune compétence",
    "skill.noSkillsHint": "Installer des compétences depuis le marché",
    "skill.marketplaceEmpty": "Aucune compétence disponible",
    "skill.invocable": "Invocable",
    "skill.back": "Dos",
    "skill.execMode": "Mode Exécution",
    "skill.allowedTools": "Outils autorisés",
    "chat.memory": "Mémoire",
    "chat.files": "Fichiers",
    "chat.online": "EN LIGNE",
    "chat.offline": "HORS LIGNE",
    "chat.research": "RECHERCHE",
    "chat.noAgents": "Aucun agent configuré",
    "chat.connecting": "De liaison...",
    "chat.selectAgent": "Sélectionnez un agent pour démarrer une conversation",
    "chat.startConversation": "Démarrer une conversation",
    "contacts.capabilities": "CAPACITÉS",
    "contacts.busy": "OCCUPÉ",
    "contacts.statusOnline": "EN LIGNE",
    "contacts.statusOffline": "HORS LIGNE",
    "team.members": "Membres",
    "team.agents": "Agents",
    "team.invite": "Inviter",
    "team.inviteTitle": "Inviter un membre",
    "team.inviteDesc": "Entrez votre adresse e-mail pour inviter un membre dans cette organisation",
    "team.email": "E-mail",
    "team.emailPlaceholder": "Entrez l'adresse e-mail",
    "team.role": "Rôle",
    "team.send": "Envoyer une invitation",
    "team.sending": "Envoi...",
    "team.sent": "Invitation envoyée",
    "team.cancel": "Annuler",
    "team.owner": "Propriétaire",
    "team.admin": "Administrateur",
    "team.member": "Membre",
    "team.remove": "Retirer",
    "team.pendingInvites": "Invitations en attente",
    "team.revoke": "Révoquer",
    "team.stats": "Statistiques",
    "team.noMembers": "Aucun autre membre pour l'instant",
    "team.noPending": "Aucune invitation en attente",
    "team.switchWorkspace": "Changer d’organisation",
    "msg.thinking": "Pensée...",
    "msg.running": "En cours d'exécution",
    "msg.error": "Une erreur s'est produite",
    "msg.toolCalls": "appel(s) d'outil terminé(s)",
    "time.justNow": "Tout à l' heure",
    "time.minutesAgo": "il y a m",
    "time.hoursAgo": "il y a h",
  },
  de: {
    "nav.memory": "Wissensbasis",
    "nav.chat": "Chatten",
    "nav.contacts": "Team",
    "nav.skillMarket": "Kompetenzmarkt",
    "nav.settings": "Einstellungen",
    "nav.meetings": "Treffen",
    "nav.briefings": "Briefings",
    "nav.ontology": "Ontologie",
    "meetings.hint": "Teambesprechungen und Protokolle",
    "meetings.create": "Neues Treffen",
    "meetings.createHint": "Starten Sie jetzt einen neuen Raum →",
    "meetings.totalMeetings": "Gesamtzahl der Besprechungen",
    "meetings.hours": "Std.",
    "meetings.minutesCount": "Minuten",
    "meetings.searchPlaceholder": "Treffen suchen...",
    "meetings.records": "Besprechungsaufzeichnungen",
    "meetings.loading": "Laden...",
    "meetings.empty": "Noch keine Treffen",
    "meetings.emptyHint": "Klicken Sie auf „Neues Meeting“, um Ihr erstes Meeting zu starten",
    "memory.title": "Geteiltes Wissen",
    "memory.documents": "Unterlagen",
    "memory.searchPlaceholder": "Wissensdatenbank durchsuchen...",
    "memory.loading": "Laden...",
    "memory.empty": "Die Wissensdatenbank ist leer",
    "memory.emptyHint": "Laden Sie .md-Dateien als gemeinsame Regeln und Wissen für alle Agenten hoch",
    "memory.back": "Zurück",
    "memory.desc": "Dokumente dienen hier als gemeinsame Regeln und Speicher für alle Agenten. Es werden nur .md-Dateien unterstützt.",
    "memory.upload": "Hochladen",
    "memory.deleteConfirm": "Dieses Dokument löschen?",
    "settings.title": "Einstellungen",
    "settings.general": "Allgemein",
    "settings.appearance": "Darstellung",
    "settings.auth": "Konto",
    "settings.guide": "Anleitung",
    "settings.about": "Über",
    "general.eyebrow": "Präferenzen",
    "general.title": "Allgemein",
    "general.desc": "Verwalten Sie Ihre Präferenzen und Organisationseinstellungen.",
    "general.displayName": "Anzeigename",
    "general.displayNamePlaceholder": "Ihr Name",
    "general.language": "Sprache",
    "general.defaultWorkDir": "Standardarbeitsverzeichnis",
    "general.defaultWorkDirHint": "Standard-Dateisystem-Root beim Erstellen neuer Agents",
    "general.chatHistory": "Chat-Verlauf",
    "general.chatHistoryDesc": "Löschen Sie alle lokalen Chat-Sitzungen. Dies kann nicht rückgängig gemacht werden.",
    "general.clearSessions": "Löschen Sie alle Sitzungen",
    "general.saved": "Gespeichert",
    "profile.open": "Profil öffnen",
    "profile.close": "Profil schließen",
    "profile.title": "Profil",
    "profile.uploadAvatar": "Neuen Avatar hochladen",
    "profile.chooseAvatar": "Wählen Sie einen Avatar",
    "profile.presetAvatar": "Voreingestellter Avatar",
    "profile.imageTypeError": "Verwenden Sie ein PNG-, JPG- oder WebP-Bild",
    "profile.imageSizeError": "Das Bild muss weniger als 2 MB groß sein",
    "profile.imageReadError": "Das Bild konnte nicht gelesen werden. Versuchen Sie es erneut.",
    "profile.saveError": "Konnte nicht gespeichert werden. Versuchen Sie es später noch einmal.",
    "auth.eyebrow": "Sicherheit",
    "auth.title": "Konto",
    "auth.desc": "Verwalten Sie Ihre Sitzungs- und Kontoeinstellungen.",
    "auth.currentToken": "Aktueller Token",
    "auth.reveal": "Anzeigen",
    "auth.hide": "Ausblenden",
    "auth.signOut": "Abmelden",
    "auth.signOutDesc": "Für den erneuten Zugriff müssen Sie das Token erneut eingeben.",
    "about.eyebrow": "System",
    "about.title": "Um",
    "about.desc": "Informationen zu dieser Anwendung.",
    "about.description": "Eine Codex-basierte Mehrkanal-KI-Agentenplattform für Web, Feishu, Telegram und WeChat.",
    "about.guideTitle": "Produktführer",
    "about.guideDesc": "Erfahren Sie mehr über NovaX-Konzepte und wie Sie die Plattform nutzen",
    "about.agreementTitle": "Benutzervereinbarung und Datenschutz",
    "about.agreementDesc": "Datenverarbeitung, Nutzungsbedingungen und Haftungsausschluss",
    "contacts.title": "Ihr Team",
    "contacts.agents": "Agent(en)",
    "contacts.online": "online",
    "contacts.newAgent": "+ Neuer Agent",
    "contacts.openChat": "Chat öffnen",
    "contacts.noAgents": "Keine Agenten konfiguriert",
    "contacts.connecting": "Verbinden...",
    "create.title": "Neuen Agenten erstellen",
    "create.name": "Name",
    "create.namePlaceholder": "z.B. Forscher",
    "create.description": "Beschreibung",
    "create.descPlaceholder": "z.B. Wissenschaftlicher Mitarbeiter",
    "create.soul": "Soul",
    "create.soulPlaceholder": "Definieren Sie die Persönlichkeit, Anweisungen und Fähigkeiten dieses Agenten ...",
    "create.cancel": "Stornieren",
    "create.create": "Erstellen",
    "create.creating": "Erstellen...",
    "create.nameRequired": "Name ist erforderlich",
    "detail.changeAvatar": "Avatar ändern",
    "detail.uploadImage": "Bild hochladen",
    "detail.choosePreset": "ODER WÄHLEN SIE EINE VOREINSTELLUNG",
    "detail.soul": "Soul",
    "detail.edit": "Bearbeiten",
    "detail.save": "Speichern",
    "detail.saving": "Sparen...",
    "detail.cancel": "Stornieren",
    "detail.noSoul": "Keine Seele konfiguriert – klicken Sie auf Bearbeiten, um eine zu erstellen",
    "detail.deleteAgent": "Agent löschen",
    "detail.confirmDelete": "Bist du sicher? Dies kann nicht rückgängig gemacht werden.",
    "detail.yesDelete": "Ja, löschen",
    "detail.deleting": "Löschen...",
    "chat.conversations": "Gespräche",
    "chat.directMessages": "Direktnachrichten",
    "chat.search": "Konversationen suchen...",
    "chat.workspace": "Organisation",
    "chat.groupAvatar": "Alle",
    "chat.groupName": "Alle",
    "chat.groupDesc": "Gruppenchat mit allen Mitgliedern und Agenten",
    "chat.newGroup": "Neue Gruppe",
    "chat.createGroup": "Gruppe erstellen",
    "chat.groupNameLabel": "Gruppenname",
    "chat.groupNamePlaceholder": "Gruppennamen eingeben...",
    "chat.selectMembers": "Wählen Sie Mitglieder aus",
    "chat.minMembers": "Wählen Sie mindestens 2 Mitglieder aus",
    "chat.creating": "Erstellen...",
    "chat.editGroup": "Gruppe bearbeiten",
    "chat.deleteGroup": "Gruppe löschen",
    "chat.deleteGroupConfirm": "Diese Gruppe löschen? Der Chatverlauf wird gelöscht.",
    "chat.groups": "Gruppen",
    "chat.messages": "Nachrichten",
    "chat.tasks": "Aufgaben",
    "chat.skill": "Fähigkeit",
    "skill.installed": "Installiert",
    "skill.marketplace": "Marktplatz",
    "skill.official": "Offiziell",
    "skill.custom": "Brauch",
    "skill.install": "Installieren",
    "skill.installing": "Installieren...",
    "skill.installed_badge": "Installiert",
    "skill.uninstall": "Deinstallieren",
    "skill.noSkills": "Keine Fähigkeiten",
    "skill.noSkillsHint": "Installieren Sie Fähigkeiten vom Markt",
    "skill.marketplaceEmpty": "Keine Fähigkeiten verfügbar",
    "skill.invocable": "Aufrufbar",
    "skill.back": "Zurück",
    "skill.execMode": "Exec-Modus",
    "skill.allowedTools": "Zulässige Werkzeuge",
    "chat.memory": "Erinnerung",
    "chat.files": "Dateien",
    "chat.online": "ONLINE",
    "chat.offline": "OFFLINE",
    "chat.research": "FORSCHUNG",
    "chat.noAgents": "Keine Agenten konfiguriert",
    "chat.connecting": "Verbinden...",
    "chat.selectAgent": "Wählen Sie einen Agenten aus, um ein Gespräch zu beginnen",
    "chat.startConversation": "Beginnen Sie ein Gespräch",
    "contacts.capabilities": "FÄHIGKEITEN",
    "contacts.busy": "BESCHÄFTIGT",
    "contacts.statusOnline": "ONLINE",
    "contacts.statusOffline": "OFFLINE",
    "team.members": "Mitglieder",
    "team.agents": "Agenten",
    "team.invite": "Einladen",
    "team.inviteTitle": "Mitglied einladen",
    "team.inviteDesc": "Geben Sie die E-Mail-Adresse ein, um ein Mitglied zu dieser Organisation einzuladen",
    "team.email": "E-Mail",
    "team.emailPlaceholder": "Geben Sie die E-Mail-Adresse ein",
    "team.role": "Rolle",
    "team.send": "Einladung senden",
    "team.sending": "Senden...",
    "team.sent": "Einladung gesendet",
    "team.cancel": "Stornieren",
    "team.owner": "Eigentümer",
    "team.admin": "Admin",
    "team.member": "Mitglied",
    "team.remove": "Entfernen",
    "team.pendingInvites": "Ausstehende Einladungen",
    "team.revoke": "Widerrufen",
    "team.stats": "Statistiken",
    "team.noMembers": "Noch keine anderen Mitglieder",
    "team.noPending": "Keine ausstehenden Einladungen",
    "team.switchWorkspace": "Organisation wechseln",
    "msg.thinking": "Denken...",
    "msg.running": "Läuft",
    "msg.error": "Es ist ein Fehler aufgetreten",
    "msg.toolCalls": "Werkzeugaufruf(e) abgeschlossen",
    "time.justNow": "Soeben",
    "time.minutesAgo": "vor m",
    "time.hoursAgo": "vor h",
  },
};
